export interface PasswordRules {
    minLenght: number;
    requireDigit: boolean;
    requireLowercase: boolean;
    requireUppercase: boolean;
    requireNonLetterOrDigit: boolean;
}

export const PasswordRuleNames: [keyof PasswordRules, (value: any) => string][] = [
    ['minLenght', (value) => `Minimální délka hesla ${value} znaků.`],
    ['requireDigit', (_) => 'Je požadována alespoň jedna číslice.'],
    ['requireLowercase', (_) => 'Je požadováno alespoň jedno malé písmeno.'],
    ['requireUppercase', (_) => 'Je požadováno alespoň jedno velké písmeno.'],
    ['requireNonLetterOrDigit', (_) => 'Je požadován alespoň jeden nealfanumerický znak (+-/* ...).'],
]

export const PasswordRuleValidators: [keyof PasswordRules, (value: any) => (v?: string) => boolean][] = [
    ['minLenght', (value) => (v?: string) => !!v && v.length >= value],
    ['requireDigit', (_) => (v?: string) => !!v && /[0-9]/.test(v)],
    ['requireLowercase', (_) => (v?: string) => !!v && /[a-z]/.test(v)],
    ['requireUppercase', (_) => (v?: string) => !!v && /[A-Z]/.test(v)],
    ['requireNonLetterOrDigit', (_) => (v?: string) => !!v && /[^\w]/.test(v)],
]